module.exports = __webpack_public_path__ + "img/qrBtn.fd9ca4ab.png";